<template>
    <div class="hello">
        <div class="hello_box">
            <Head :hasEnter="false" :hasProject="true"></Head>
            <div class="menu">
                <div class="menu_bar">
                    <div class="bar_item" :class="selectIndex == 1 || activeIndex == 1 ? 'active' : ''"
                        @mouseenter="fnchangeSelect('1')" @mouseleave="fnchangeSelect('0')">
                        <span>项目信息</span>
                        <el-collapse-transition>
                            <div class="submenu" v-show="selectIndex == 1 && isOpen == true">
                                <div class="sub_item" @click="fnRefresh('/projectExtendDefault', '1')">
                                    <span>本平台项目信息</span></div>
                                <div class="sub_item" @click="fnRefresh('/enterInfo', '1')"><span>企业信息</span></div>
                                <div class="sub_item" @click="fnRefresh('/projectinfo', '1')"><span>人社厅项目信息</span></div>
                                <div class="sub_item" @click="fnRefresh('/subcontract', '1')"><span>贵阳建委分包单位</span>
                                </div>
                                <div class="sub_item" @click="fnRefresh('/projectExtend', '1')"><span>贵阳建委平台密匙</span>
                                </div>
                                <div class="sub_item" @click="fnRefresh('/GzDockingSituation', '1')">
                                    <span>人社厅对接情况</span></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                    <div class="bar_item" :class="selectIndex == 2 || activeIndex == 2 ? 'active' : ''"
                        @mouseenter="fnchangeSelect('2')" @mouseleave="fnchangeSelect('0')">
                        <span>实名制管理</span>
                        <el-collapse-transition>
                            <div class="submenu" v-show="selectIndex == 2 && isOpen == true">
                                <div class="sub_item" @click="fnRefresh('/personnelStatistics', '2')"><span>人员统计</span>
                                </div>
                                <div class="sub_item" @click="fnRefresh('/person', '2')"><span>人员管理</span></div>
                                <div class="sub_item" @click="fnRefresh('/task', '2')"><span>任务管理</span></div>
                                <div class="sub_item" @click="fnRefresh('/attendance', '2')"><span>考勤管理</span></div>
                                <div class="sub_item" @click="fnRefresh('/team', '2')"><span>班组管理</span></div>
                                <div class="sub_item" @click="fnRefresh('/salary', '2')"><span>工资管理</span></div>
                                <div class="sub_item" @click="fnRefresh('/personnelAudit', '2')"><span>人员审核</span></div>
                                <div class="sub_item" @click="fnRefresh('/abnormal', '2')"><span>异常人员</span></div>
                                <div class="sub_item" @click="fnRefresh('/blackMenu', '2')"><span>人员黑名单</span></div>
								<div class="sub_item" @click="fnRefresh('/behavior', '2')"><span>人员诚信行为</span></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                    <div class="bar_item" :class="selectIndex == 3 || activeIndex == 3 ? 'active' : ''"
                        @mouseenter="fnchangeSelect('3')" @mouseleave="fnchangeSelect('0')">
                        <span>视频监控</span>
                        <el-collapse-transition>
                            <div class="submenu" v-show="selectIndex == 3 && isOpen == true">
                                <div class="sub_item" @click="fnRefresh('/monitorlive', '3')"><span>直播画面</span></div>
                                <div class="sub_item" @click="fnRefresh('/monitorscreen', '3')"><span>监控画面</span></div>
								<div class="sub_item" @click="fnOpenGb"><span>国标接入</span></div>
								<div class="sub_item" @click="fnRefresh('/timelapse', '3')"><span>延时摄影</span></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                    <div class="bar_item" :class="selectIndex == 4 || activeIndex == 4 ? 'active' : ''"
                        @mouseenter="fnchangeSelect('4')" @mouseleave="fnchangeSelect('0')">
                        <span>智能硬件</span>
                        <el-collapse-transition>
                            <div class="submenu" v-show="selectIndex == 4 && isOpen == true">
                                <div class="sub_item" @click="fnRefresh('/access', '4')"><span>门禁设备</span></div>
                                <div class="sub_item" @click="fnRefresh('/tower', '4')"><span>塔机黑匣子</span></div>
                                <div class="sub_item" @click="fnRefresh('/environment', '4')"><span>环境监测</span></div>
                                <div class="sub_item" @click="fnRefresh('/elevator', '4')"><span>升降机黑匣子</span></div>
                                <div class="sub_item" @click="fnRefresh('/led', '4')"><span>LED控制主板</span></div>
                                <div class="sub_item" @click="fnRefresh('/helmet', '4')"><span>AI监测</span></div>
                                <div class="sub_item" @click="fnRefresh('/unloading', '4')"><span>卸料平台</span></div>
                                <div class="sub_item" @click="fnRefresh('/broadcast', '4')"><span>云广播</span></div>
                                <div class="sub_item" @click="APP.fnRefreshHardHat"><span>智能安全帽</span></div>
                                <div class="sub_item" @click="fnRefresh('/alarmPanel', '4')"><span>混合报警</span></div>
                            </div>
                        </el-collapse-transition>
                    </div>
					<div class="bar_item" :class="selectIndex == 5 || activeIndex == 5 ? 'active' : ''" @mouseenter="fnchangeSelect('5')" @mouseleave="fnchangeSelect('0')">
						<span>安全巡检</span>
						<el-collapse-transition>
							<div class="submenu" v-show="selectIndex == 5 && isOpen == true">
								<div class="sub_item sub_level2"><span>质量管理</span><i class="sub_arrow"></i></div>

                                <div class="sub_item sub_level3" @click="fnRefresh('/quality', '5')"><span>质量统计</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/qualityInspection', '5')"><span>巡检记录</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/qualityInspectionSet', '5')"><span>巡检设置</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/qualityCheckPerson', '5')"><span>巡检人管理</span></div>
                                <div class="sub_item sub_level2"><span>安全管理</span><i class="sub_arrow"></i></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/safety', '5')"><span>安全统计</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/safetyInspection', '5')"><span>巡检记录</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/safetyInspectionSet', '5')"><span>巡检设置</span></div>
                                <div class="sub_item sub_level3" @click="fnRefresh('/safetyCheckPerson', '5')"><span>巡检人管理</span></div>
                            
							</div>
						</el-collapse-transition>
					</div>
                    <div class="bar_item" :class="selectIndex == 7 || activeIndex == 7 ? 'active' : ''"
                        v-on:mouseenter="fnchangeSelect('7')" v-on:mouseleave="fnchangeSelect('0')">
                        <span>专项教育</span>
                        <el-collapse-transition>
                            <div class="submenu" v-show="selectIndex == 7 && isOpen == true">
                                <div class="sub_item" @click="fnRefresh('/specialTrain', '7')"><span>专项培训</span></div>
                                <div class="sub_item" @click="fnRefresh('/specialExam', '7')"><span>专项考试</span></div>
                                <div class="sub_item" @click="fnRefresh('/totalTrain', '7')"><span>培训统计</span></div>
                                <div class="sub_item" @click="fnRefresh('/totalExam', '7')"><span>考试统计</span></div>
                                <div class="sub_item" @click="fnRefresh('/testManage', '7')"><span>题库管理</span></div>
								<div class="sub_item" @click="fnOpenCodeTrain"><span>码上培训</span></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                					<div class="bar_item" :class="selectIndex == 8 || activeIndex == 8 ? 'active' : ''" @mouseenter="fnchangeSelect('8')" @mouseleave="fnchangeSelect('0')">
						<span>数字工地</span>
						<el-collapse-transition>
							<div class="submenu" v-show="selectIndex == 8 && isOpen == true">
								<div class="sub_item" @click="fnRefresh('/solidWaste', '8')"><span>固废管理</span></div>
								<div class="sub_item" @click="fnRefresh('/digitalSite', '8')"><span>数字化管理</span></div>
								<div class="sub_item" @click="fnRefresh('/bimModel', '8')"><span>BIM模型</span></div>
							</div>
						</el-collapse-transition>
					</div>
</div>
                <!-- 导航路由出口 -->
                <div class="router-wrap">
                    <router-view></router-view>
                </div>
                <!-- 底部版权信息 -->
                <div class="copy_box">
                    <div class="copy">渝ICP备18011947号-2</div>
                    <div class="copy">平台版本号：V-1.1.0</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getActiveIndex,
        setActiveIndex
    } from '@/utils/auth.js';
    import Head from '@/views/Header/HeaderDefault/headerProjectSelect';
    import store from '../../../store';
    import APP from '@/utils/base';
import selectMenuExtras from '@/mixins/selectMenuExtras';


    export default {
        mixins: [selectMenuExtras],
        data() {
            return {
                APP: APP,
                selectIndex: '0',
                isOpen: false
            };
        },
        components: {
            Head
        },
        computed: {
            activeIndex() {
                return store.state.active.activeIndex;
            }
        },
        created() {
            let _activeIndex = getActiveIndex();
            store.dispatch('ChangeIndex', _activeIndex);
        },
        methods: {
            // 路由跳转
            fnRefresh(_url, _activeIndex) {
                setActiveIndex(_activeIndex);
                store.dispatch('ChangeIndex', _activeIndex);
                if (_url === this.$route.path) {
                    this.$router.push({
                        path: '/redirect',
                        query: _url
                    });
                } else {
                    this.$router.push({
                        path: _url
                    });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/view/selectMenu.scss';
</style>



// WEBPACK FOOTER //
// src/views/SelectMenu/selectMenuGy/index.vue